import { GET_API } from "../../Functionalities/APIs";
import { partnerAdminResponsivenessUrl } from "../../Constants/apiUrls";

export const responseQuery = ({ from, to, branch }) =>
  [from ? `from=${from}` : "", to ? `to=${to}` : "", branch ? `branch=${branch}` : ""].filter(Boolean).join("&");

export const loadResponsiveness = async (filters) => {
  const result = await GET_API("", responseQuery(filters), partnerAdminResponsivenessUrl);
  return result && result.data ? result.data : null;
};

export const formatSeconds = (seconds) => {
  if (seconds === null || seconds === undefined) return "—";
  if (seconds < 60) return `${seconds} s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min ${seconds % 60} s`;
  return `${Math.floor(minutes / 60)} h ${minutes % 60} min`;
};

export const rateTone = (rate) => (rate >= 90 ? "good" : rate >= 60 ? "warn" : "bad");
